import React, { useMemo } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import PageContent from 'components/enrollment-packet/PageContent';
import { EnrollmentPacketPageStore, EnrollmentPacketPageStoreContext } from 'store/pages/enrollment-packet/pageStore';
import { useHistory, useParams } from 'react-router-dom';
import { HEADER_SPACING_PRESETS, PageHeader } from '@insurancemenu/imenu-components-lib';
import { CARD_DATA } from 'global/checklists-helpers/ChecklistHelper';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { observer } from 'mobx-react-lite';
import { DateStyled } from './styles';
import { createStyles } from '../../globalStyles';

const EnrollmentPacketPage: React.FC = observer(() => {
  const { periodId } = useParams<{ periodId: string }>();
  const pageStore = useMemo(() => new EnrollmentPacketPageStore({ enrollmentPeriodId: periodId }), []);

  const history = useHistory();

  const onBackButtonClick = (): void => {
    history.goBack();
  };

  const classes = createStyles();
  const showCreationDate = !pageStore.isLoading && pageStore.creationDate;

  return (
    <ProposalStatusLayout>
      <EnrollmentPacketPageStoreContext.Provider value={pageStore}>
        <div className={classes.pageWrapper}>
          <PageHeader
            title={CARD_DATA.BUILD.title}
            subtitle={CARD_DATA.BUILD.text}
            spacing={showCreationDate ? HEADER_SPACING_PRESETS.withActionBelow : HEADER_SPACING_PRESETS.default}
            onBackButtonClick={onBackButtonClick}
          />
          {showCreationDate && (
            <DateStyled>{`Generated on: ${normDateToShortAmericanDate(pageStore.creationDate)}`}</DateStyled>
          )}

          <PageContent />
        </div>
      </EnrollmentPacketPageStoreContext.Provider>
    </ProposalStatusLayout>
  );
});

export default EnrollmentPacketPage;
